var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1),_c('BgImage'),_c('transition',{attrs:{"name":"fade"}},[(_vm.shareModalVisible)?_c('ShareModal'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }